import { render, staticRenderFns } from "./UtilityDetailLink.vue?vue&type=template&id=53fa7c2a&scoped=true"
import script from "./UtilityDetailLink.vue?vue&type=script&lang=js"
export * from "./UtilityDetailLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fa7c2a",
  null
  
)

export default component.exports